import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { SVGComponent } from '@/types/types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from './ESettingsWorkspaceTab';

export interface Props {
  type: string;
  Icon?: SVGComponent;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
}

export function ButtonSettingsWorkspaceTab({ type, Icon, setActiveTab }: Props) {
  //FIELDS
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { page_settings_workspace_current_tab } = use_slice_ui(['page_settings_workspace_current_tab']);

  const [isMouseOver, setIsMouseOver] = useState(false);

  /*
   * EVENTS
   */

  function onClick() {
    dispatch(LOCAL__ui_set_string({ key: 'page_settings_workspace_current_tab', value: type, valid_values: Object.values(ESettingsWorkspaceTab) }));

    setActiveTab?.(EPagesMobileTabs.SETTINGS_PARAMS);
  }

  /*
   * RENDERS
   */

  function render_icon() {
    let out = <></>;

    if (Icon) {
      out = (
        <Icon
          className={`!w-5 !h-5 !hover-animation 
            ${isMouseOver || page_settings_workspace_current_tab == type ? '!text-bar' : '!text-component-item-foreground'}`}
        />
      );
    }

    return out;
  }

  /*
   * HTML
   */
  return (
    <div className="w-full px-2">
      <div
        className={`list-item-wrapper hover-animation gap-5
        ${page_settings_workspace_current_tab == type || isMouseOver ? 'list-item-selected ' : ''}`}
        onClick={onClick}
        onMouseEnter={() => setIsMouseOver(true)}
        onMouseLeave={() => setIsMouseOver(false)}
      >
        {render_icon()}
        <div className="list-item-inner">
          <p className={`text-left m-0`}>{t(i18n_page_settings_workspace.tabs[type].title)}</p>
        </div>
      </div>
    </div>
  );
}
